var value_selector, value_group_selector;

// var product_additional_amount = 0;

$('.collection-list-slick').slick({
  infinite: false,
  slidesToShow: 4, 
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev btn--plain slick-custom-arrow"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg></button>',
  nextArrow: '<button class="slick-next btn--plain slick-custom-arrow"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg></button>',
  draggable: false 
});


/* Tabs for Coaching pages ============== */
/* ==================================== */
$('.iframe-tab-label').click(function() {
  var chooseTab = $(this).attr('data-tab-content');

  // Remove active state from tab
  $('.iframe-tab-label').removeClass('iframe-tab-label--active');
  $(this).addClass('iframe-tab-label--active');

  // Hide and Show tab triggered
  $('.iframe-tab-content').hide();
  $('#' + chooseTab).fadeIn();
});


/* Custom Upgrade Racket ============== */
/* ==================================== */
$('.init-upgrade').on('change', function() {
  // Get group
  var group_selector = $(this.value);

  if (group_selector.selector != 'default') {
    // Clean all Droppers
    $('.input-dropper').val('');

    // Print Properties input
    $('.custom-group--child').hide();
    $('div[data-target-group=' + group_selector.selector + ']').show();
    $('div[data-target-group=stencil-upgrade]').show(); 

    // Print Properties input
    selected = $(this).find('option:selected');
    name = selected.data('name');

    $('#propertie--string-upgrade').val(name); 
  } else {
    // Clean all Droppers
    $('.input-dropper').val('');
    $('.custom-group--child').hide();
    $('div[data-target-group=stencil-upgrade]').hide();
  }
});

$('.custom-upgrade-selector').on('change', function() {  
  // Get Values
  var input_selector = $(this).attr('data-drop');
  value_selector = $(this.value);

  // Print Properties input
  selected = $(this).find('option:selected');
  type = selected.data('type');
  rel_id = selected.data('rel-id');
  price = selected.data('price');
  name = selected.data('name');

  if (type == 'price') {
    // Math for the additionalCost
    number_price = price * 1;
    product_additional_amount = product_additional_amount + number_price;
    // $('#additional-cost--' + rel_id).val(product_additional_amount);
    jQuery.post('/cart/update.js', `attributes[Additional Cost]=${ product_additional_amount }`);

    // Print the value on input
    $('#' + input_selector).val(price + ' # ' + name);
  } else {
    $('#' + input_selector).val(name);
  }
});


/* Custom Upgrade Racket –– Cart Page = */
/* ==================================== */
const url = 'https://ph-sports.herokuapp.com/draft-order/'; 
// Post request
async function sendDraftOrder(url, payload) {
  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });
  return await response.json();
}

$('#custom-checkout').click(function(event) {
// $('#cart-checkout').submit( function(event){

  $(this).prop('disabled', true);
  $(this).addClass('btn--disabled');
  $(this).html('processing...');

  event.preventDefault();
  const cart_object = fetch('/cart.js')
  .then(response => response.json())
  .then(data => {
    cart_data = data;

    if($.isEmptyObject(cart_data.attributes) == false) {
			console.log('beforee',cart_data);
      sendDraftOrder(url, cart_data)
      .then((data) => {
        	console.log('before',data);
        window.location.href = data.response;
 				console.log('after',data);
      })
      .catch((error) => {
        console.log(error);
        $(this).prop('disabled', false);
        $(this).removeClass('btn--disabled');
        $(this).html('Check Out');
      });

    } else {
      // $('#cart-checkout').submit();
      $('#regular-checkout').click();
      $(this).prop('disabled', false);
      $(this).removeClass('btn--disabled');
      $(this).html('Check Out');
    }

    // return cart_data;
  });

});




// collection filter js 

$(document).ready(function(){
$('.filter_checked').click(function(){
  //$('.filter_checked').css( 'pointer-events', 'none' );
    if (this.previous) {
        this.checked = false;
    }
    this.previous = this.checked;
  	if(this.checked == true){
      	var click_tag = $(this).attr("data-tag");
        console.log(click_tag);
        var found = false;
       $(".filter_checked").parent().hide();
       $(".filter_checked").addClass("unchecked");
         $(".filter_checked").each(function(){
          found = false;
          var tag_el = $(this).attr("data-tag");
          var tt = $('.active_tag').attr("data-tag");


          $(".collection-product-list .product-block").each(function(){
            if($(this).hasClass(click_tag) == true && $(this).hasClass(tag_el) == true){
              found = true;
            }
          })
          console.log(found)
          if(found){
            $(this).parent().show();
            $(this).removeClass("unchecked");
          //$(this).prop("checked",true);
          }

        });
      $('.filter_checked').each(function(){
        console.log($(this).is(':visible'))
        if(!$(this).is(':visible')){
          $(this).removeAttr('checked');
        }
      })
      
      var tags = [];
 		$(this).addClass("active_tag");
        $('.filter_checked').each(function () {
            var $this = $(this),
                tag = $this.attr('data-tag');


            if ($(this).prop('checked')) {
                tags.push(tag);
            }

        });
     	var tag_val = tags.toString().replace(/,/g, '.');
    	$(".product-block").hide();
    	$(".product-block."+tag_val).show();
     // $('.filter_checked').css( 'pointer-events', 'all' );
        // $.each(tags, function(key, value) {

        //      $(".product-block."+value).show();
        // });

            //$(".product-block").show();
      
  	}else{
      var len_ch = $('input[type="radio"]:is(:checked)').length;
      $(this).removeClass("active_tag"); 
      var click_tag = $(this).attr("data-tag");
        console.log(click_tag)
        var found = false;
      if(len_ch == 0){
        $(".filter_checked").parent().show();
        $(".filter_checked").each(function(){
          found = false;
          var tag_el = $(this).attr("data-tag");
          $(".collection-product-list .product-block").each(function(){
            if($(this).hasClass(tag_el) == true ){
              found = true;
            }
          })
          if(found){
            $(this).parent().show();
          //$(this).prop("checked",true);
          }else{
          	$(this).parent().hide();
          }
	
        });
      }else{
      $(".filter_checked").parent().hide();
      }
       
       $(".filter_checked").addClass("unchecked");
         $(".filter_checked").each(function(){
          found = false;
          var tag_el = $(this).attr("data-tag");
          var tt = $('.active_tag').attr("data-tag");


          $(".collection-product-list .product-block").each(function(){
            if($(this).hasClass(tag_el) == true && $(this).hasClass(tt) == true){
              found = true;
            }
          })
          console.log(found)
          if(found){
            $(this).parent().show();
            $(this).removeClass("unchecked");
          //$(this).prop("checked",true);
          }
	
        });
      $('.filter_checked').each(function(){
        if(!$(this).is(':visible')){
          $(this).removeAttr('checked');
        }
      })
      var tags = [];
      $('.filter_checked').each(function () {

        var $this = $(this),
            tag = $this.attr('data-tag');


        if ($(this).prop('checked')) {
          tags.push(tag);
        }

      });
      var tag_val = tags.toString().replace(/__COMMA__/g, '.');
      if (tags.length === 0) {
        $(".collection-product-list .grid__item .product-block").show();
      }else{
        $(".product-block").hide();
      }
      $(".product-block."+tag_val).show();
     // $('.filter_checked').css( 'pointer-events', 'all' );
  }
 
 	var highestBox = 0;
      
      $('.collection-product-list .product-block').each(function(){
        
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }
      
      });  
      $('.collection-product-list .product-block').height(highestBox);
  
  	
});


 var highestBox = 0;
      
      $('.collection-product-list .product-block').each(function(){
        
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }
      
      });  
      $('.collection-product-list .product-block').height(highestBox);
  
  
$(".filter_checked").each(function(){
          found = false;
          var tag_el = $(this).attr("data-tag");
          $(".collection-product-list .product-block").each(function(){
            if($(this).hasClass(tag_el) == true ){
              found = true;
            }
          })
          if(found){
            $(this).parent().show();
          //$(this).prop("checked",true);
          }else{
          	$(this).parent().hide();
            var data_name = $(this).attr("name");
            $(this).parent().addClass(data_name);
            $(".sidebar-filter__label."+data_name).hide();
            
          }
	
        });
  



  var items = [];
  $('.filter__checked').click(function(){
    var tid = $(this).attr('data-tag');
    var coll_url = window.location.href;
    var coll_div = $('.col_products');
    //console.log(tid);
    var index = items.indexOf(tid);
    if($(this).is(':checked')){
      items.push(tid);
    } else{
      if (index > -1) {
        items.splice(index, 1);
      }
    }
    //console.log(items);  
    let text = items.toString();
    var url_filter = text.replace(/,/g, "+")
    //console.log(url_filter);
    var href=coll_url+'/'+url_filter;
    console.log(href);
    $.ajax({
      url:href,
      type:'GET',
      beforeSend: function() {
        // setting a timeout
        coll_div.hide();
        $('.loading').removeClass('hide');
      },
      success: function(data){
   //window.history.replaceState('', '', href);
        var count = $(data).find('.col_products .product-block').length;
        console.log(count);
        var new_html = $(data).find('.col_products').html();
       // console.log(new_html);
        coll_div.html(new_html);
        if(count == 0){
          var text = '  ';
          $('.cc-filters-results__summary').removeClass('hide');
        } else if (count == 1) {
          var text = 'product';
          $('.cc-filters-results__summary').removeClass('hide');
        } else {
          var text = 'products';
          $('.cc-filters-results__summary').removeClass('hide');
        }
        $('.cc-filters-results__summary').text(count + ' ' + text );
        //window.history.pushState("object or string", "Title", href);
      },
      complete: function() {
        $('.loading').addClass('hide');
        coll_div.fadeIn();
        // clear.removeClass('hide');
        return false;
      }
    });
  });
});

$(document).ready(function(){
  $('.tab_link').click(function(){
    if($(window).width() < 768) {
      $(this).toggleClass('tab_link_active');
      $(this).next().slideToggle();
    }
  });
  
//   //$('#quantity__wrapper .add').click(function () {
// 	  $(document).on('click', '#quantity__wrapper .add', function(){
// 		if ($(this).prev().val() < 3) {	}
//     	$(this).prev().val(+$(this).prev().val() + 1);
	
// });
// //$('#quantity__wrapper .sub').click(function () {
// 		  $(document).on('click', '#quantity__wrapper .sub', function(){
// 		if ($(this).next().val() > 1) {
//     	if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
// 		}
// });
  
  $('.add').click(function () {
		if ($(this).prev().val() < 3) {}
    	$(this).prev().val(+$(this).prev().val() + 1);
		
});
$('.sub').click(function () {
		if ($(this).next().val() > 1) {
    	if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
		}
});
  

  $('.mob-filter-open').click(function() {
    $('.mob-filter').show();
  });
  $('.mob-filter-close').click(function() {
    $('.mob-filter').hide();
  });

});